export default __webpack_public_path__ + "static/media/img-contrato.e43703f6.jpg";